import manifestLogo from "@/assets/manifest-logo.webp";
import { cn } from "@/lib/utils";

interface AppLoaderProps {
  className?: string;
}

export default function AppLoader({ className }: AppLoaderProps) {
  return (
    <div className={cn("flex min-h-screen flex-col items-center justify-center gap-4", className)}>
      <div className="relative">
        <div className="h-14 w-14 rounded-2xl overflow-hidden shadow-md">
          <img src={manifestLogo} alt="Manifest" className="h-full w-full object-contain" />
        </div>
        <div className="absolute inset-0 rounded-2xl animate-pulse ring-2 ring-primary/30" />
      </div>
      <div className="flex items-center gap-1.5">
        <div className="h-1.5 w-1.5 rounded-full bg-primary animate-bounce [animation-delay:0ms]" />
        <div className="h-1.5 w-1.5 rounded-full bg-primary animate-bounce [animation-delay:150ms]" />
        <div className="h-1.5 w-1.5 rounded-full bg-primary animate-bounce [animation-delay:300ms]" />
      </div>
    </div>
  );
}
